import { render, staticRenderFns } from "./uploadfilemore.vue?vue&type=template&id=0d7aaff0&scoped=true&"
import script from "./uploadfilemore.vue?vue&type=script&lang=js&"
export * from "./uploadfilemore.vue?vue&type=script&lang=js&"
import style0 from "./uploadfilemore.vue?vue&type=style&index=0&id=0d7aaff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7aaff0",
  null
  
)

export default component.exports